// @flow
import { createValidator } from 'gandi.react-form';

import type { ClaimsFormProps, FormData } from './ClaimsForm';

function mustBeTrue(
  value: FormData['claim'],
  data: FormData,
  props: ClaimsFormProps,
) {
  if (value !== true) {
    return props.__('You must read and approve this trademark notification');
  }

  return undefined;
}

export default (createValidator({
  claim: mustBeTrue,
}): any);
